<template>
  <Visitor>
      <div class="bg-gray-100 min-h-screen">
        
        <main class>
          <div class="max-w-7xl mx-auto py-8 sm:px-6 lg:px-8 text-center">
            <div class="sm:flex px-4">
              <div class="sm:w-1/2 bg-white overflow-hidden shadow rounded-lg sm:mr-2">
                <div
                  class="h-48 w-full flex-none bg-cover rounded-t text-center overflow-hidden"
                  style="background-image: url('https://image.freepik.com/foto-gratis/bonito-carpintero-nivel-burbuja_1098-15261.jpg')"
                  title="Woman holding a mug"
                ></div>
                <div class="px-4 py-5 sm:p-4 text-left">
                  <h2 class="text-2xl font-semibold leading-none">{{ title }}</h2>
                  <div class="mt-4">
                    <h3 class="font-semibold">Descripción:</h3>
                    <p class="sm:text-justify">{{ description }}</p>

                    <h3 class="font-semibold mt-4">Ubicación:</h3>
                    <div class="flex items-center mt-1">
                      <IconSvg
                        :solid="true"
                        icon="location-marker"
                        class="h-5 w-5 text-primary-500"
                      />
                      <div class="text-sm ml-1">
                        <p
                          class="text-gray-900 font-semibold leading-none"
                        >{{ province }}, {{ district }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sm:w-1/2 sm:ml-2 mt-4 sm:mt-0" style="height: fit-content;">
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <div class="flex items-center">
                      <div>
                        <img
                          @click="imageOpen = true"
                          class="inline-block h-16 w-16 sm:h-20 sm:w-20 rounded-full cursor-pointer"
                          src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80"
                          alt
                        />
                      </div>
                      <div class="ml-6 text-left">
                        <p class="text-lg leading-5 font-semibold text-gray-700">Proveedor:</p>
                        <p
                          class="text-sm leading-4 font-medium text-gray-500 mt-2"
                        >{{ supplier_name }}</p>
                      </div>
                    </div>
                    <div class="flex items-center mt-2 justify-between">
                      <div class="flex items-center mt-2">
                        <IconSvg :solid="true" icon="star" class="h-5 w-5 text-yellow-400" />
                        <div class="text-sm ml-1">
                          <p
                            class="text-gray-900 font-semibold leading-none"
                          >Calificación: {{ supplier_rating }}</p>
                        </div>
                      </div>
                      <router-link
                        class="inline-flex rounded-md shadow-sm ml-2"
                        :to="'/service/' + this.$route.params.serviceId + '/cost'"
                      >
                        <button
                          type="button"
                          class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                        >Cotizar</button>
                      </router-link>
                    </div>
                  </div>
                </div>
                <p
                  @click="guideOpen=true"
                  class="text-lg leading-5 font-semibold text-gray-700 mt-6 cursor-pointer hover:text-primary-500 hover:underline"
                >Guía de primeros pasos</p>
              </div>
            </div>
          </div>
        </main>
        <div
          v-show="imageOpen"
          class="fixed inset-x-0 px-4 pb-6 inset-0 p-0 flex items-center justify-center"
        >
          <div @click="imageOpen = false" class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <div
            class="px-4 pt-5 pb-4 overflow-hidden transform transition-all"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <img
              class="inline-block h-32 w-32 sm:h-64 sm:w-64 rounded-full"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80"
              alt
            />
          </div>
        </div>
        <div
          v-show="guideOpen"
          class="fixed inset-x-0 px-4 pb-6 inset-0 p-0 flex items-center justify-center"
        >
          <div @click="guideOpen = false" class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <div
            class="px-4 pt-5 pb-4 overflow-hidden transform transition-all"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <iframe width="600" height="400" src="https://www.youtube.com/watch?v=inb8MMZ-QmA"></iframe>
          </div>
        </div>
      </div>
  </Visitor>
</template>

<script>
import api from "../../api";

import IconSvg from "../../components/IconSvg";
import Visitor from "../Layouts/Visitor";

export default {
  name: "ServiceDetails",
  components: {
    IconSvg,
    Visitor
  },
  data() {
    return {
      imageOpen: false,
      guideOpen: false,

      title: "",
      description: "",
      department: "",
      province: "",
      district: "",
      min_price: "",
      max_price: "",

      supplier_name: "",
      supplier_rating: "",
    };
  },
  async mounted() {
    let response = await api.get(`/service/${this.$route.params.serviceId}`);
    if (!response.ok) {
      return;
    }
    this.title = response.data.title || "";
    this.description = response.data.description || "";
    this.department = response.data.department || "";
    this.province = response.data.province || "";
    this.district = response.data.district || "";
    this.min_price = response.data.min_price || "";
    this.max_price = response.data.max_price || "";

    this.supplier_name = response.data.supplier_name || "";
    this.supplier_rating = response.data.supplier_rating || "";
  },
};
</script>